import type { SecodaAIProposalOut, SuggestMonitorArg } from '@repo/api-codegen';
import type { IBaseModel } from '@repo/common/models/baseModel';
import { useMemo, type MouseEvent } from 'react';
import IntegrationLogo from '../../../IntegrationLogo/IntegrationLogo';
import { SuggestionItemTable } from './SuggestionItemTable';

type MonitorSuggestionWithBaseModel = SuggestMonitorArg & IBaseModel;

export interface MonitorSuggestionTableProps {
	suggestions: {
		proposal: SecodaAIProposalOut;
		data: SuggestMonitorArg;
	}[];
	onRowClick: (
		row: SuggestMonitorArg & IBaseModel,
		index: number,
		event: MouseEvent
	) => void;
}

export function MonitorSuggestionTable({
	suggestions,
	onRowClick,
}: MonitorSuggestionTableProps) {
	const records = useMemo(
		() =>
			suggestions.map((suggestion) => ({
				...suggestion.data,
				id: suggestion.proposal.id,
				created_at: suggestion.proposal.created_at,
				updated_at: suggestion.proposal.updated_at,
			})),
		[suggestions]
	);

	return (
		<SuggestionItemTable<MonitorSuggestionWithBaseModel>
			items={records}
			iconRenderer={(item) => (
				<IntegrationLogo integrationId={item.integration_id} size={16} />
			)}
			titleSelector={(item) => item.name}
			subTextSelector={() => 'Create monitor'}
			onItemClick={onRowClick}
		/>
	);
}
